import { Main, Container } from "../styled";
import close_icone from "../../../../../assets/icons/close.svg";
import edit_icon from "../../../../../assets/icons/edit.svg";
import { useState } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../../../utils/config";
import Loading from "../../../../components/Loading";
import AlertDialog from "../../../../components/AlertDialog";
import AlterarNomeModal from "../AlterarNomeModal";
import AlterarSobreModal from "../AlterarSobreModal";
import AlterarEstadoModal from "../AlterarEstadoModal";
import AlterarCapaModal from "../AlterarCapaModal";
import AlterarAdministradoresModal from "../AlterarAdministradoresModal";
import { useEffect } from "react";
import DeleteDialog from "../../../../components/DeleteDialog";
import Toast from "../../../../components/Toast";
import InformacoesGrupoController from "../controller";
import { useNavigate } from "react-router-dom";

function InformacoesGrupoModal({grupo, setGrupo, onClose, errors, setErrors, subgruposCount = 0}){
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAlterarNomeModal, setShowAlterarNomeModal] = useState(false);
  const [showAlterarSobreModal, setShowAlterarSobreModal] = useState(false);
  const [showAlterarEstadoModal, setShowAlterarEstadoModal] = useState(false);
  const [showAlterarCapaModal, setShowAlterarCapaModal] = useState(false);
  const [showAlterarAdministradoresModal, setShowAlterarAdministradoresModal] = useState(false);
  const [showdeletarGrupoModal, setShowdeletarGrupoModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countAdministradores, setConuntAdministradores] =useState(0);
  const navigate = useNavigate();
  // Aviso amigavel (regra de negocio explicada) -- nao e erro, entao nao usa o toast vermelho.
  const [aviso, setAviso] = useState("");
  useEffect(() => {
    if (!aviso) return undefined;
    const t = setTimeout(() => setAviso(""), 8000);
    return () => clearTimeout(t);
  }, [aviso]);

  const ehSubgrupo = grupo.tipo !== "Grupo Principal";
  // Regra: so se exclui grupo vazio. O servidor e a fonte da verdade (devolve 409); aqui
  // se avisa ANTES de abrir a confirmacao, com os dados ja carregados.
  function pedirExclusao() {
    // desconta a propria pessoa so se ela tem vinculo (o admin do pai nao tem no subgrupo)
    const eu = (grupo.is_membro ?? grupo.is_participante) ? 1 : 0;
    const outrosParticipantes = Math.max(0, Number(grupo.quantidade_usuarios || 0) - eu);
    if (outrosParticipantes > 0) {
      setAviso(`Este ${ehSubgrupo ? "subgrupo" : "grupo"} ainda tem participantes. Remova-os antes de excluir o ${ehSubgrupo ? "subgrupo" : "grupo"}.`);
      return;
    }
    // Subgrupo NAO barra aqui: subgrupo vazio vai junto com o grupo. Se houver gente nos
    // subgrupos, o servidor responde 409 e o mesmo aviso amigavel aparece.
    setShowdeletarGrupoModal(true);
  }
  const closeModal = onClose;

  const informacoesGrupoController = new InformacoesGrupoController(grupo, setGrupo, errors, setErrors, setLoading);

  useEffect(()=>{
    let count = 0;
    grupo.administradores.map((administador)=>{
      if(administador.is_admin){
        count++;
      }
    });
    setConuntAdministradores(count);
  }, [grupo.administradores, grupo])

  
  return(
    <Main>
      <Toast variante="info" error={aviso} />
      {loading && <Loading titulo={"Aguarde"} subtitulo={"Estamos deixando tudo pronto para você..."}/>}
      {showAlterarNomeModal && <AlterarNomeModal grupo={grupo} setGrupo={setGrupo} onClose={()=>setShowAlterarNomeModal(false)}/>}
      {showAlterarSobreModal && <AlterarSobreModal grupo={grupo} setGrupo={setGrupo} onClose={()=>setShowAlterarSobreModal(false)}/>}
      {showAlterarCapaModal && <AlterarCapaModal grupo={grupo} setGrupo={setGrupo} onClose={()=>setShowAlterarCapaModal(false)}/>}
      {showAlterarEstadoModal && <AlterarEstadoModal grupo={grupo} setGrupo={setGrupo} onClose={()=>setShowAlterarEstadoModal(false)}/>}
      {showAlterarAdministradoresModal && <AlterarAdministradoresModal grupo={grupo} setGrupo={setGrupo} onClose={()=>setShowAlterarAdministradoresModal(false)}/>}
      
      {showdeletarGrupoModal && <DeleteDialog 
        titulo={`Deseja deletar este ${grupo.tipo === "Grupo Principal" ? "grupo" : "subgrupo"}?`} 
        subtitulo={"Todos os dados e postagens do grupo serão excluídos."}
        onClose={()=>setShowdeletarGrupoModal(false)}
        onDelete={()=>{
          informacoesGrupoController.deleteGrupo(()=>{
            setShowSuccess(true);
            setShowdeletarGrupoModal(false); 
          }, (mensagem)=>{
            setShowdeletarGrupoModal(false);
            setAviso(mensagem);
          })
          
        } }

      />}
      {showSuccess &&
          <AlertDialog
            titulo={`${grupo.tipo === "Grupo Principal" ? "Grupo" : "Subgrupo"} deletado com sucesso!`} 
            buttonText={"Ver grupos"} 
            buttonOnClick={()=>{
              navigate('/grupos');
            }}
          />
        }
      <Container>
        <section>
          <div className="close" onClick={closeModal}>
            <button type="button">
              <img src={close_icone} alt="Icone de fechar"/>
            </button>
          </div>
        </section>

        <section>
          <div className="title">
            <h2>Informações do {grupo.tipo === "Grupo Principal" ? "grupo" : "subgrupo"}</h2>
          </div>
        </section>  

        <section className="painel">
            <section className="card">

              <div className="list">
                <div className="item border">
                  <label>Capa</label>
                  <div className="content-item">
                    <span>{grupo.foto_capa?.path ? "Imagem personalizada" : "Imagem padrão"}</span>
                    <img src={edit_icon} alt="Alterar capa" role="button" tabIndex={0} onClick={()=>{setShowAlterarCapaModal(true)}}
                      onKeyDown={(e)=>{ if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setShowAlterarCapaModal(true); } }}/>
                  </div>
                </div>
              </div>

              <div className="list">
                <div className="item border">
                  <label>Nome</label>
                  <div className="content-item">
                    <span>{grupo.nome}</span>
                    <img src={edit_icon} alt="Icone de editar" onClick={()=>{setShowAlterarNomeModal(true)}}/>
                  </div>
                </div>
              </div>

              <div className="list">
                <div className="item border">
                  <label>Sobre</label>
                  <div className="content-item">
                    <span>{grupo.sobre}</span>
                    <img src={edit_icon} alt="Icone de editar" onClick={()=>{setShowAlterarSobreModal(true)}}/>
                  </div>
                  
                </div>
              </div>

              <div className="list">
                <div className="item border">
                  <label>Estado</label>
                  <div className="content-item">
                    <span>{grupo.estado}</span>
                    <img src={edit_icon} alt="Icone de editar" onClick={()=>{setShowAlterarEstadoModal(true)}}/>
                  </div>
                  
                </div>
              </div>

              <div className="list">
                <div className="item border">
                  <label>Administradores</label>
                  <div className="content-item">
                    <span>{countAdministradores}</span>
                    <img src={edit_icon} alt="Icone de editar" onClick={()=>{setShowAlterarAdministradoresModal(true                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           )}}/>
                  </div>
                </div>
              </div>

              <button className="delete-account" onClick={pedirExclusao}>Deletar {ehSubgrupo ? "subgrupo" : "grupo"}</button>
            
            </section>     
        </section>
      </Container>
    </Main>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(InformacoesGrupoModal);